var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useReducer, } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { getArchivedTasksRequest } from "../api/api";
import { SET_ARCHIVE_TASKS, SET_FULL_PAGE_LOADING, } from "../constants";
import { reducer } from "../reducers/archive-reducer";
import { WPQTArchiveDoneFilter } from "../types/enums";
import { LoadingContext } from "./LoadingContextProvider";
const initialState = {
    archivedTasks: null,
    archiveLoading: false,
    archiveSearchValue: "",
    archiveFilteredPipelineId: "",
    archiveTaskDoneFilter: WPQTArchiveDoneFilter.All,
};
const ArchiveContext = createContext({
    state: initialState,
    archiveDispatch: () => { },
});
const ArchiveContextProvider = ({ children, }) => {
    const [state, archiveDispatch] = useReducer(reducer, initialState);
    const { loadingDispatch } = useContext(LoadingContext);
    useEffect(() => {
        fetchAndSetArchivedTasks();
    }, []);
    const fetchAndSetArchivedTasks = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            loadingDispatch({
                type: SET_FULL_PAGE_LOADING,
                payload: true,
            });
            const { data } = yield getArchivedTasksRequest();
            archiveDispatch({ type: SET_ARCHIVE_TASKS, payload: data });
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to fetch archived tasks", "quicktasker"));
        }
        finally {
            loadingDispatch({
                type: SET_FULL_PAGE_LOADING,
                payload: false,
            });
        }
    });
    return (_jsx(ArchiveContext.Provider, { value: { state, archiveDispatch }, children: children }));
};
export { ArchiveContext, ArchiveContextProvider };
